/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionMergeComponent = function (unit) {
    Merge2MissionUnitComponent.call(this, unit);
};

Merge2MissionMergeComponent.prototype = Object.create(Merge2MissionUnitComponent.prototype);
Merge2MissionMergeComponent.prototype.constructor = Merge2MissionMergeComponent;

Merge2MissionMergeComponent.prototype.canMergeWith = function (otherUnit) {
    if (Merge2MissionFamilies.isLastStage(this.unit.code, this.unit.stage) || this.unit.getType() === Merge2MissionFamilies.TYPE.INGREDIENT) {
        return false;
    }

    return otherUnit.code === this.unit.code && otherUnit.stage === this.unit.stage;
};

Merge2MissionMergeComponent.prototype.getMergeResult = function (otherUnit) {
    if (!this.unit.isMergeable() || !otherUnit.isMergeable()) {
        return undefined;
    }

    if (!this.canMergeWith(otherUnit)) {
        return undefined;
    }

    return { code: this.unit.code, stage: this.unit.stage + 1 };
};
